import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { INTERCEPT_RULE_TOOL_NAME } from './portal-tool.constants';

export { INTERCEPT_RULE_TOOL_NAME };

export const InterceptRuleActionSchema = z.enum([
  'list',
  'add',
  'update',
  'remove',
]);

export const InterceptRuleInputSchema = z.object({
  name: z.string(),
  urlPattern: z.string(),
  methods: z.array(z.string()).optional(),
  enabled: z.boolean().optional(),
  description: z.string().optional(),
});

export const InterceptRuleToolInputSchema = z.object({
  action: InterceptRuleActionSchema,
  ruleId: z.string().optional(),
  rule: InterceptRuleInputSchema.optional(),
  nameFilter: z.string().optional(),
});

export const InterceptRuleSummarySchema = z.object({
  ruleId: z.string(),
  ruleName: z.string(),
  urlPattern: z.string(),
  methods: z.array(z.string()),
  enabled: z.boolean(),
  description: z.string().optional(),
});

export const InterceptRuleDataSchema = z.object({
  ruleId: z.string().optional(),
  ruleName: z.string().optional(),
  ruleCount: z.number(),
  rules: z.array(InterceptRuleSummarySchema).optional(),
});

export const InterceptRuleOutputSchema = createPortalToolOutputSchema({
  dataSchema: InterceptRuleDataSchema,
});

export type InterceptRuleToolInput = z.infer<
  typeof InterceptRuleToolInputSchema
>;
export type InterceptRuleSummary = z.infer<typeof InterceptRuleSummarySchema>;
export type InterceptRuleOutput = z.infer<typeof InterceptRuleOutputSchema>;
export type InterceptRuleData = z.infer<typeof InterceptRuleDataSchema>;
